import React, { useState } from "react";

const Toogle = ({ checked, setChecked,labels }) => {
  const handleChange = () => {
    setChecked(!checked);
  };

  return (
    <div className="toggle-container" onClick={handleChange}>
      <div
        className={`dialog-button ${checked?"bg-login":"bg-login"}  ${
          checked ? "disabled" : ""
        }`}
        style={{fontSize:"17px"}}
      >
        {checked ? labels[1] : labels[0]}
      </div>
    </div>
  );
};

export default Toogle;
